import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  ArrowToLeft,
  CameraIcon,
  EmptyBooking,
  EmptyNft,
  UnVerified,
  VerifyUserIcon,
} from "../../../AssetComponents/Images";
import { PurpleButton } from "../../../Components/Buttons/PurpleButton";
import { BlackButton } from "../../../Components/Buttons/BlackButton";
import { Review } from "../../../Components/Review/Review";
import { useEffect, useRef, useState } from "react";
import Modal from "react-responsive-modal";
import AvatarEditor from "react-avatar-editor";
import InputSlider from "react-input-slider";
import { ReclaimZKP } from "../../../Components/ReclaimZKP/Reclaim";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import { setAuthToken } from "../../../Components/functions/Api";
import { setCurrentProfile } from "../../../Layouts/DashboardLayouts";
import { getProfileFromWallet } from "../../../Components/functions/Functions";
import imageCompression from "browser-image-compression";
import { RentalItem } from "../../../Components/RealEstateProperty/RentalItem";
import { Fade } from "react-awesome-reveal";
import { api } from "../../../Components/functions/Api";
import { setProfile } from "../../../ReduxSlices/AuthSlice";
import Verify from "../../../assets/images/Verify";
import { VerificationStatus } from "../../../Components/VerificationStatus/VerificationStatus";
import { getRoleSpecificVerification } from "../../../utils/verificationUtils";

async function compressImage(imageFile) {
  console.log("originalFile instanceof Blob", imageFile instanceof Blob);
  console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

  // ✅ Improved compression settings for better quality
  const options = {
    maxSizeMB: 0.5, // ✅ Increased from 0.05 to 0.5 MB (10x larger)
    maxWidthOrHeight: 400, // ✅ Increased from 130 to 400px for better quality
    useWebWorker: true,
    fileType: 'image/jpeg', // ✅ Specify JPEG for better compression
    initialQuality: 0.9, // ✅ High quality (90%)
  };
  
  try {
    const compressedFile = await imageCompression(imageFile, options);
    console.log(
      "compressedFile instanceof Blob",
      compressedFile instanceof Blob
    );
    console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`);
    return compressedFile;
  } catch (error) {
    console.log("Compression error:", error);
    // ✅ Fallback: return original file if compression fails
    return imageFile;
  }
}

//**blob to dataURL**
function blobToDataURL(blob, callback) {
  var a = new FileReader();
  a.onload = function (e) {
    callback(e.target.result);
  };
  a.readAsDataURL(blob);
}

const CropperModal = ({
  src,
  modalOpen,
  setModalOpen,
  setPreview,
  setFile,
}) => {
  const [slideValue, setSlideValue] = useState(10);
  const cropRef = useRef(null);
  //handle save
  const handleSave = async () => {
    if (cropRef) {
      // ✅ Get high-quality image from AvatarEditor
      const dataUrl = cropRef.current.getImage().toDataURL('image/jpeg', 0.95); // ✅ High quality JPEG
      const result = await fetch(dataUrl);

      const blob = await result.blob();
      const compressed = await compressImage(blob);
      
      // ✅ Use the compressed image for storage
      blobToDataURL(compressed, function (dataurl) {
        setFile(dataurl);
      });

      // ✅ Use the compressed image for preview
      setPreview(URL.createObjectURL(compressed));
      setModalOpen(false);
    }
  };

  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      center
      classNames={{
        modal:
          "min-w-[300px] sm:min-w-[360px] min-h-[200px] sm:min-h-[400px] rounded-[8px] border-[1px] border-[#E3E3E3] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] w-[95vw] sm:w-auto max-w-[400px] profile-cropper-modal-mobile",
      }}
    >
      <div className="p-[12px] sm:p-[16px] w-full sm:w-[360px] profile-cropper-content-mobile">
        <div className="mx-auto text-center my-[15px] sm:my-[20px] text-[16px] sm:text-[20px] font-semibold">
          Crop your avatar
        </div>
        <div className="flex justify-center">
          <AvatarEditor
            ref={cropRef}
            image={src}
            border={30}
            borderRadius={100}
            color={[0, 0, 0, 0.72]}
            scale={slideValue / 10}
            rotate={0}
            width={300} // ✅ Fixed width for better quality
            height={300} // ✅ Fixed height for better quality
            className="mx-auto rounded-[12px] sm:rounded-[16px] max-w-[280px] sm:max-w-[320px] profile-cropper-avatar-mobile"
          />
        </div>

        <div className="my-[15px] sm:my-[20px] flex justify-center">
          <InputSlider
            styles={{
              track: {
                height: "4px",
                background: "#e9ecef",
              },
              active: {
                background: "#5b1dee",
              },
            }}
            xmin={10}
            xmax={50}
            x={slideValue}
            axis="x"
            onChange={({ x }) => setSlideValue(x)}
          />
        </div>
        <div className="grid grid-cols-2 gap-[15px] sm:gap-[20px] profile-cropper-buttons-mobile">
          <PurpleButton text="Save" onClick={handleSave} />
          <BlackButton text="Cancel" onClick={(e) => setModalOpen(false)} />
        </div>
      </div>
    </Modal>
  );
};

export const Profile = () => {
  const navigate = useNavigate();
  const [listings, setListings] = useState([]);
  const params = useParams();
  const [modalOpen, setModalOpen] = useState(false);
  const [src, setSrc] = useState(null);
  const nfts = useSelector((state) => state.nft.nfts);
  const [preview, setPreview] = useState(null);
  const inputRef = useRef(null);
  const location = useLocation();
  const [mode, setMode] = useState();
  const currentProfile = useSelector((state) => state.auth.profile);
  const account = useSelector((state) => state.auth.account);
  
  // ✅ CRITICAL: Use ref to track if verification just happened
  const justVerifiedRef = useRef(false);
  const verificationDataRef = useRef(null);
  
  // ✅ NEW: Store the viewed profile data (for viewing other users' profiles)
  const [viewedProfile, setViewedProfile] = useState(null);
  
  const [profile, setProfiles] = useState({
    avatar: currentProfile?.Avatar || "",
    firstName: currentProfile?.Name?.split("/")[0] || "",
    lastName: currentProfile?.Name?.split("/")[1] || "",
    ID: currentProfile?.ID || "",
    email: currentProfile?.Email || "",
    company: currentProfile?.Company || "",
    bio: currentProfile?.Bio || "",
    review: currentProfile?.Review || [],
    isVerified: currentProfile?.isVerified || false,
  });

  // ✅ Update local profile state when currentProfile changes
  useEffect(() => {
    if (currentProfile) {
      console.log("🔄 Updating local profile state from Redux:", {
        isVerified: currentProfile?.isVerified,
        verificationLevel: currentProfile?.verificationLevel,
        hasID: !!currentProfile?.ID,
        IDlength: currentProfile?.ID?.length || 0,
        currentLocalID: profile.ID?.substring(0, 50),
        currentLocalIDLength: profile.ID?.length,
        justVerified: justVerifiedRef.current
      });
      
      // ✅ CRITICAL FIX: If user just verified, use the stored verification data
      let idToUse = currentProfile?.ID || "";
      
      if (justVerifiedRef.current && verificationDataRef.current) {
        console.log("🔐 Using stored verification data from ref");
        console.log("   → Verification data length:", verificationDataRef.current.length);
        idToUse = verificationDataRef.current;
        // Reset the flag after using it
        justVerifiedRef.current = false;
      } else if (profile.ID && profile.ID.includes("/")) {
        // If local profile already has verification, preserve it
        console.log("⚠️ Preserving local ID with verification data");
        idToUse = profile.ID;
      } else if (currentProfile?.ID && currentProfile.ID.includes("/")) {
        // Use Redux ID if it has verification
        console.log("✅ Using Redux ID with verification");
        idToUse = currentProfile.ID;
      }
      
      console.log("   → Final ID to use (first 50):", idToUse?.substring(0, 50));
      console.log("   → Final ID length:", idToUse?.length);
      
      setProfiles({
        avatar: currentProfile?.Avatar || "",
        firstName: currentProfile?.Name?.split("/")[0] || "",
        lastName: currentProfile?.Name?.split("/")[1] || "",
        ID: idToUse,
        email: currentProfile?.Email || "",
        company: currentProfile?.Company || "",
        bio: currentProfile?.Bio || "",
        review: currentProfile?.Review || [],
        isVerified: currentProfile?.isVerified || false,
      });
    }
  }, [currentProfile]);
  const dispatch = useDispatch();
  const handleImgChange = (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;
      
      // ✅ Validate file type
      if (!file.type.startsWith('image/')) {
        toast.error('Please select a valid image file');
        return;
      }
      
      // ✅ Validate file size (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        toast.error('Image size should be less than 10MB');
        return;
      }
      
      setSrc(URL.createObjectURL(file));
      setModalOpen(true);
    } catch (error) {
      console.log('Image upload error:', error);
      toast.error('Failed to load image. Please try again.');
    }
  };
  const handleInputClick = (e) => {
    e.preventDefault();
    inputRef.current.click();
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get("mode")) setMode(searchParams.get("mode"));
  }, [location.search]);

  useEffect(() => {
    const nfts_ = Object.values(nfts);
    const temp = [];
    for (let i = 0; i < nfts_.length; i++) {
      if (nfts_[i].access.owner === account && nfts_[i].short.islisted)
        temp.push(nfts_[i]);
    }
    setListings(temp);
  }, [nfts]);

  function generateRandom8DigitInteger() {
    return Math.floor(10000000 + Math.random() * 90000000);
  }


  // ✅ NEW: Auto-save function for verification completion
  const autoSaveOnVerification = async (verificationData) => {
    try {
      console.log("🔄 [RECLAIM] Auto-save triggered on verification completion");
      console.log("   → Verification source: Reclaim Protocol");
      console.log("   → Verification data length:", verificationData?.length || 0);
      console.log("   → Verification data preview:", verificationData?.substring(0, 200));
      console.log("   → Timestamp:", new Date().toISOString());
      
      // ✅ Validate required fields
      if (!profile.avatar || !profile.firstName || !profile.lastName || !profile.email) {
        console.error("❌ Auto-save failed: Missing required fields");
        const missingFields = [];
        if (!profile.firstName) missingFields.push("First name");
        if (!profile.lastName) missingFields.push("Last name");
        if (!profile.email) missingFields.push("Email");
        if (!profile.avatar) missingFields.push("Avatar");
        toast.warning(
          `Verification received, but auto-save needs more info: ${missingFields.join(", ")}. Please complete your profile and tap Save.`,
          { autoClose: 5000 }
        );
        return;
      }

      // ✅ Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(profile.email)) {
        console.error("❌ Auto-save failed: Invalid email format");
        toast.warning("Please enter a valid email to auto-save your profile.", {
          autoClose: 4000,
        });
        return;
      }

      // ✅ Prepare profile data for auto-save
      const profileData = {
        walletAddress: account,
        Avatar: profile.avatar,
        Bio: profile.bio || "",
        Name: profile.firstName + "/" + profile.lastName,
        Company: profile.company || "",
        ID: verificationData, // Use the verification data directly
        Email: profile.email,
      };

      console.log("📤 Auto-save: Sending profile data to backend");
      console.log("   → walletAddress:", profileData.walletAddress);
      console.log("   → Name:", profileData.Name);
      console.log("   → Email:", profileData.Email);
      console.log("   → ID (first 100 chars):", profileData.ID?.substring(0, 100));
      console.log("   → ID length:", profileData.ID?.length);
      console.log("   → ID contains verification (has '/'):", profileData.ID?.includes("/"));

      // Call the auto-save endpoint
      const res = await api("profile/autoSaveOnVerification", profileData);
      
      console.log("📥 Auto-save: Received response from backend");
      console.log("   → success:", res?.success);
      console.log("   → profile.isVerified:", res?.profile?.isVerified);
      console.log("   → profile.verificationLevel:", res?.profile?.verificationLevel);
      console.log("   → profile.verifications:", res?.profile?.verifications);
      console.log("   → error:", res?.error);
      console.log("   → message:", res?.message);

      if (res && res.success) {
        // ✅ Update Redux state with the saved profile
        if (res.profile) {
          dispatch(setProfile(res.profile));
          console.log("✅ Auto-save: Profile updated in Redux state");
          console.log("   → isVerified:", res.profile.isVerified);
          console.log("   → verificationLevel:", res.profile.verificationLevel);
        }
        
        // ✅ Refresh profile from backend to ensure we have latest data
        try {
          const refreshedProfile = await api("profile/getProfile", {
            walletAddress: account,
          });
          if (refreshedProfile) {
            dispatch(setProfile(refreshedProfile));
            console.log("✅ Auto-save: Profile refreshed from backend");
          }
        } catch (refreshError) {
          console.warn("⚠️ Failed to refresh profile after auto-save:", refreshError);
        }
        
        toast.success("✅ Verification successful! Your profile has been updated with data from Reclaim Protocol.", {
          autoClose: 5000,
        });
      } else {
        const backendMessage = res?.error || res?.message || "Unknown error";
        console.error("❌ Auto-save failed:", backendMessage);
        console.error("   → Full response:", res);
        
        // ✅ Detailed error message for user
        let errorMessage = "Verification failed";
        if (backendMessage.includes("Invalid verification data")) {
          errorMessage = "Verification data is invalid. Please try verifying again.";
        } else if (backendMessage.includes("Name validation")) {
          errorMessage = "Name doesn't match verification. Please check your name matches your Emirates ID.";
        } else if (backendMessage.includes("Email")) {
          errorMessage = backendMessage;
        } else {
          errorMessage = `Verification failed: ${backendMessage}`;
        }
        
        toast.error(errorMessage, {
          autoClose: 8000,
        });
        
        // ✅ Also show info toast suggesting manual save
        toast.info("You can try saving your profile manually using the 'Save changes' button.", {
          autoClose: 6000,
        });
      }
    } catch (error) {
      console.error("❌ Auto-save error:", error);
      console.error("   → Error type:", error.name);
      console.error("   → Error message:", error.message);
      console.error("   → Response status:", error.response?.status);
      console.error("   → Response data:", error.response?.data);
      
      const frontendMessage =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Network error";
      
      // ✅ Detailed error message
      let errorMessage = "Verification save failed";
      if (frontendMessage.includes("Invalid verification data")) {
        errorMessage = "Verification data is invalid. Please try verifying again.";
      } else if (frontendMessage.includes("Network") || error.response?.status >= 500) {
        errorMessage = "Server error. Please try again in a moment.";
      } else if (error.response?.status === 400) {
        errorMessage = `Verification failed: ${frontendMessage}`;
      } else {
        errorMessage = `Error: ${frontendMessage}`;
      }
      
      toast.error(errorMessage, {
        autoClose: 8000,
      });
      
      // ✅ Also show info toast suggesting manual save
      toast.info("You can try saving your profile manually using the 'Save changes' button.", {
        autoClose: 6000,
      });
    }
  };

  const submitChanges = async () => {
    if (
      !profile.avatar ||
      !profile.firstName ||
      !profile.lastName ||
      !profile.email
    ) {
      toast.error("You missed necessary fields.");
      return;
    }

    // ✅ Validate email format on frontend
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(profile.email)) {
      toast.error("Please enter a valid email address.");
      return;
    }


    toast.loading("Uploading your profile..");
    
    try {
      // ✅ CRITICAL FIX: Preserve verification data when saving profile
      // Priority: profile.ID (just verified) > currentProfile.ID (existing) > generate new
      let profileID = profile.ID || currentProfile?.ID || generateRandom8DigitInteger().toString();
      
      // ✅ EXTRA SAFETY: If profile.ID has verification but profileID doesn't, use profile.ID
      if (profile.ID && profile.ID.includes("/") && !profileID.includes("/")) {
        console.log("⚠️ Safety check: Using profile.ID because it has verification data");
        profileID = profile.ID;
      }
      
      // ✅ EXTRA SAFETY: If currentProfile has verification but profileID doesn't, merge them
      if (currentProfile?.ID && currentProfile.ID.includes("/") && !profileID.includes("/")) {
        console.log("⚠️ Safety check: Merging currentProfile.ID because it has verification data");
        profileID = profileID + currentProfile.ID.substring(currentProfile.ID.indexOf("/"));
      }
      
      console.log("📝 ========== SAVING PROFILE ==========");
      console.log("📝 Profile ID (first 100 chars):", profileID?.substring(0, 100));
      console.log("📝 Profile ID full length:", profileID?.length);
      console.log("📝 Profile ID has verification data:", profileID?.includes("/"));
      console.log("📝 Current verification status:", {
        isVerified: currentProfile?.isVerified || profile.isVerified,
        verificationLevel: currentProfile?.verificationLevel
      });
      console.log("📝 Profile state:", {
        firstName: profile.firstName,
        lastName: profile.lastName,
        email: profile.email,
        hasAvatar: !!profile.avatar,
        ID: profile.ID?.substring(0, 50)
      });
      
      // Create profile data in the expected format
      const profileData = {
        walletAddress: account,
        Avatar: profile.avatar,
        Bio: profile.bio || "",
        Name: profile.firstName + "/" + profile.lastName,
        Company: profile.company || "",
        ID: profileID, // ✅ Use preserved ID
        Email: profile.email,
        // ✅ SECURITY: Do NOT set isVerified on frontend - backend will validate proof and set it
        // isVerified: backend determines this by validating the proof data in ID field
      };
      
      console.log("📤 Sending profile data to backend:");
      console.log("   → walletAddress:", profileData.walletAddress);
      console.log("   → Name:", profileData.Name);
      console.log("   → Email:", profileData.Email);
      console.log("   → ID (first 100 chars):", profileData.ID?.substring(0, 100));
      console.log("   → ID length:", profileData.ID?.length);
      console.log("   → Has verification proof (contains /):", profileData.ID?.includes("/"));
      console.log("   → isVerified: NOT SET (backend will validate proof and determine this)");
      
      // ✅ DETAILED LOGGING: Log the complete request body
      console.log("🔍 COMPLETE REQUEST BODY:");
      console.log("   → Full profileData object:", JSON.stringify(profileData, null, 2));
      console.log("   → Data types:", {
        walletAddress: typeof profileData.walletAddress,
        Name: typeof profileData.Name,
        Email: typeof profileData.Email,
        ID: typeof profileData.ID,
        Avatar: typeof profileData.Avatar,
        Bio: typeof profileData.Bio,
        Company: typeof profileData.Company
      });
      console.log("   → Field lengths:", {
        walletAddress: profileData.walletAddress?.length,
        Name: profileData.Name?.length,
        Email: profileData.Email?.length,
        ID: profileData.ID?.length,
        Avatar: profileData.Avatar?.length,
        Bio: profileData.Bio?.length,
        Company: profileData.Company?.length
      });
      console.log("   → Required fields check:", {
        hasWalletAddress: !!profileData.walletAddress,
        hasName: !!profileData.Name,
        hasEmail: !!profileData.Email
      });
      
      // Use the api function with the correct path
      const res = await api("profile/uploadProfile", profileData);
      
      console.log("📥 Received response from backend:");
      console.log("   → success:", res?.success);
      console.log("   → profile.isVerified:", res?.profile?.isVerified);
      console.log("   → profile.verificationLevel:", res?.profile?.verificationLevel);
      console.log("   → profile.ID (first 100):", res?.profile?.ID?.substring(0, 100));
      console.log("   → kyc.verified:", res?.profile?.verifications?.kyc?.verified);
      console.log("   → emiratesId.verified:", res?.profile?.verifications?.emiratesId?.verified);
      console.log("📝 ========== SAVE COMPLETE ==========");
      
      // ✅ Handle new backend response format
      if (res && res.success) {
        toast.dismiss();
        
        // ✅ Use the profile data returned from backend
        if (res.profile) {
          dispatch(setProfile(res.profile));
        } else {
          // Fallback: fetch updated profile
          const updatedProfile = await api("profile/getProfile", {
            walletAddress: account,
          });
          dispatch(setProfile(updatedProfile));
        }
        
        toast.success(res.message || "Changes are saved!", {
          autoClose: 2000,
        });
      } else {
        // ✅ Handle backend error response
        const errorMessage = res?.error || "Failed to save profile changes";
        toast.error(errorMessage, {
          autoClose: 5000,
        });
      }
    } catch (error) {
      toast.dismiss();
      console.error("Profile update error:", error);
      
      // ✅ DETAILED ERROR LOGGING
      console.error("🔍 ERROR DETAILS:");
      console.error("   → Error type:", error.name);
      console.error("   → Error message:", error.message);
      console.error("   → Error code:", error.code);
      console.error("   → Response status:", error.response?.status);
      console.error("   → Response data:", error.response?.data);
      console.error("   → Request config:", {
        url: error.config?.url,
        method: error.config?.method,
        data: error.config?.data
      });
      
      // ✅ Better error handling with specific messages
      let errorMessage = "Failed to save profile changes";
      
      if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
        console.error("   → Backend error:", error.response.data.error);
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      toast.error(errorMessage, {
        autoClose: 5000,
      });
    }
  };

  const getCustomProfile = async (address) => {
    const res = await getProfileFromWallet(address);
    // ✅ CRITICAL FIX: Store the full profile data including verification status
    setViewedProfile(res); // Store full profile for VerificationStatus component
    setProfiles({
      avatar: res?.Avatar,
      firstName: res?.Name?.split("/")[0] || "",
      lastName: res?.Name?.split("/")[1] || "",
      ID: res?.ID || "",
      email: res?.Email || "",
      company: res?.Company || "",
      bio: res?.Bio || "",
      review: res?.Reviews || [],
      isVerified: res?.isVerified || false, // ✅ Store verification status
    });
  };

  useEffect(() => {
    if (params.address) getCustomProfile(params.address);
  }, [params.address]);

  // ✅ NEW: Refresh profile on mount to ensure verification status is up to date
  useEffect(() => {
    if (!params.address && account) {
      const refreshProfile = async () => {
        try {
          console.log("🔄 Refreshing profile on mount to check verification status");
          const refreshedProfile = await api("profile/getProfile", {
            walletAddress: account,
          });
          if (refreshedProfile) {
            dispatch(setProfile(refreshedProfile));
            console.log("✅ Profile refreshed on mount:", {
              isVerified: refreshedProfile.isVerified,
              verificationLevel: refreshedProfile.verificationLevel
            });
          }
        } catch (error) {
          console.warn("⚠️ Failed to refresh profile on mount:", error);
        }
      };
      refreshProfile();
    }
  }, [account, params.address, dispatch]);

  useEffect(() => {
    console.log(profile.ID);
  }, [profile.ID]);

  return (
    <div className="w-full h-[calc(100vh-120px)] overflow-auto">
      <div className="space-y-[20px] w-[95vw] sm:w-[90vw] md:w-[80vw] my-[20px] mx-auto max-w-[800px] px-4 sm:px-0 profile-container-mobile">
        <Fade cascade>
          <div className="flex items-center gap-[10px]">
            <div
              onClick={() => navigate(-1)}
              className="bg-white cursor-pointer hover:translate-x-[-4px] hover:bg-[#f6f6f6] p-[4px] w-max rounded-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.80),2px_2px_6px_0px_rgba(187,195,206,0.60)]"
            >
              <ArrowToLeft />
            </div>
            {!params.address && (
              <div className="text-[18px] sm:text-[20px] font-semibold profile-header-mobile">Your profile</div>
            )}
          </div>
          <div className="mt-[20px] flex flex-col lg:flex-row gap-[40px] lg:gap-[100px] w-full justify-between items-start profile-layout-mobile">
            <div className="w-full lg:w-max flex items-center flex-col">
              {preview || profile?.avatar ? (
                <img
                  alt="Profile"
                  src={preview || profile?.avatar}
                  className="w-[120px] sm:w-[150px] h-[120px] sm:h-[150px] rounded-full shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] profile-avatar-mobile object-cover"
                  style={{
                    imageRendering: 'high-quality', // ✅ Better image rendering
                    imageRendering: '-webkit-optimize-contrast', // ✅ WebKit optimization
                  }}
                />
              ) : (
                <VerifyUserIcon className="w-[120px] sm:w-[150px] profile-avatar-mobile" />
              )}

              <input
                type="file"
                accept="image/*"
                ref={inputRef}
                onChange={handleImgChange}
                hidden
              />

              <CropperModal
                modalOpen={modalOpen}
                src={src}
                setPreview={setPreview}
                setModalOpen={setModalOpen}
                setFile={(value) => setProfiles({ ...profile, avatar: value })}
              />

              <div
                hidden={params.address}
                onClick={handleInputClick}
                className="mt-[-10px] hover:translate-y-[-4px] mb-[20px] sm:mb-[30px] px-[6px] py-[2px] rounded-[12px] bg-gradient-to-b from-[#5b1deec0] from-0% to-70% to-[#5b1dee] text-white cursor-pointer shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] profile-upload-button-mobile"
              >
                <div className="flex items-center gap-[4px]">
                  <CameraIcon />
                  <div className="font-normal text-sm sm:text-base">Upload</div>
                </div>
              </div>
              <VerificationStatus 
                showWarning={true}
                className="profile-status-mobile"
                role={mode || 'host'}
                profile={params.address ? viewedProfile : null} // ✅ CRITICAL FIX: Pass viewed profile when viewing someone else
              />
            </div>
            <div className="w-full space-y-[15px] sm:space-y-[20px] profile-form-mobile">
              <div className="w-full gap-[15px] sm:gap-[20px] grid grid-cols-1 sm:grid-cols-2 profile-grid-mobile">
                <div className="w-full space-y-[8px] sm:space-y-[10px] profile-section-mobile">
                  <div className="font-semibold text-sm sm:text-base">First name</div>
                  <div className={`px-[10px] sm:px-[12px] w-full py-[8px] border-[2px] border-[#E3E3E3] rounded-[10px] sm:rounded-[12px] ${params.address ? 'bg-white' : 'bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]'}`}>
                    <input
                      disabled={params.address}
                      className={`outline-none w-full text-sm sm:text-base profile-input-mobile ${params.address ? 'bg-white text-gray-900' : ''}`}
                      style={params.address ? { backgroundColor: 'white', color: '#111827' } : {}}
                      value={profile.firstName}
                      onChange={(e) =>
                        setProfiles({ ...profile, firstName: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="w-full space-y-[8px] sm:space-y-[10px] profile-section-mobile">
                  <div className="font-semibold text-sm sm:text-base">Last name</div>
                  <div className={`px-[10px] sm:px-[12px] w-full py-[8px] border-[2px] border-[#E3E3E3] rounded-[10px] sm:rounded-[12px] ${params.address ? 'bg-white' : 'bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]'}`}>
                    <input
                      disabled={params.address}
                      className={`outline-none w-full text-sm sm:text-base profile-input-mobile ${params.address ? 'bg-white text-gray-900' : ''}`}
                      style={params.address ? { backgroundColor: 'white', color: '#111827' } : {}}
                      value={profile.lastName}
                      onChange={(e) =>
                        setProfiles({ ...profile, lastName: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="space-y-[15px] sm:space-y-[20px]" hidden={params.address}>
                {mode !== "traveler" && (
                  <div className="w-full space-y-[8px] sm:space-y-[10px]" hidden>
                    <div className="font-semibold text-sm sm:text-base">ID</div>
                    <div className="bg-white px-[10px] sm:px-[12px] w-full py-[8px] border-[2px] border-[#E3E3E3] rounded-[10px] sm:rounded-[12px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                      <input
                        className="outline-none w-full text-sm sm:text-base profile-input-mobile"
                        value={profile.ID}
                        disabled
                      />
                    </div>
                  </div>
                )}

                {/* ✅ NEW: Host verification flow - Step 1: KYC first */}
                {mode === "host" && (
                  <div className="text-[#7E7E7E] text-sm sm:text-base bg-transparent">
                    {(() => {
                      const hasKyc = currentProfile?.verifications?.kyc?.verified || false;
                      const hasEmiratesId = currentProfile?.verifications?.emiratesId?.verified || false;
                      
                      if (!hasKyc) {
                        return "Step 1: First verify your identity with one of the KYC providers below. This verifies your name.";
                      } else if (hasKyc && !hasEmiratesId) {
                        return "Step 2: Now verify your Emirates ID to complete host verification.";
                      } else {
                        return "You are fully verified as a host (KYC + Emirates ID).";
                      }
                    })()}
                  </div>
                )}

                {mode === "traveler" && (
                  <div className="text-[#7E7E7E] text-sm sm:text-base">
                    Use one of following ZKP providers which you are ready to
                    verify your Identity
                  </div>
                )}

                <div className="flex justify-end gap-2 sm:gap-3 flex-wrap profile-verification-mobile">
                  {/* ✅ NEW: Host verification - Show KYC options first if not completed */}
                  {mode === "host" && !(currentProfile?.verifications?.kyc?.verified || false) && (
                    <>
                      <ReclaimZKP
                        providerId={2}
                        txt={"Coinbase KYC"}
                        profileFirstName={profile.firstName}
                        profileLastName={profile.lastName}
                        setReturn={(value) => {
                          console.log("🔐 [RECLAIM] Received Coinbase KYC proof data from Reclaim Protocol (Host):");
                          console.log("   → Proof data length:", value?.length || 0);
                          console.log("   → Proof data preview:", value?.substring(0, 200));
                          console.log("   → Verification source: Reclaim Protocol");
                          console.log("   → Verification type: KYC (Host Step 1)");
                          console.log("   → Provider: Coinbase");
                          console.log("   → Timestamp:", new Date().toISOString());
                          
                          // ✅ FIX: Prevent duplicate proof appending
                          const currentParts = (profile.ID || "").split("/");
                          const basePart = currentParts[0] || (account || generateRandom8DigitInteger().toString());
                          const existingProofs = currentParts.slice(1).filter(p => p && p !== "");
                          
                          // Check if this exact proof already exists
                          const proofAlreadyExists = existingProofs.some(p => p === value);
                          
                          let newID;
                          if (proofAlreadyExists) {
                            console.log("⚠️ Proof already exists in ID, not appending duplicate");
                            newID = profile.ID;
                          } else {
                            console.log("✅ Appending new proof to ID");
                            newID = basePart + "/" + value;
                          }
                          
                          console.log("   → New profile.ID length:", newID.length);
                          console.log("   → New profile.ID preview:", newID.substring(0, 200));
                          
                          // ✅ CRITICAL: Store in ref to survive Redux updates
                          justVerifiedRef.current = true;
                          verificationDataRef.current = newID;
                          console.log("   → Stored in verificationDataRef");
                          
                          // ✅ SECURITY: Do NOT set isVerified here - let backend validate the proof
                          const updatedProfile = { 
                            ...profile, 
                            ID: newID
                            // isVerified will be set by backend after validating the proof
                          };
                          
                          setProfiles(updatedProfile);
                          
                          // ✅ Update Redux state with proof data (backend will validate and set isVerified)
                          if (value && currentProfile) {
                            const updatedReduxProfile = {
                              ...currentProfile,
                              ID: newID
                              // Let backend set isVerified and verificationLevel after validation
                            };
                            console.log("   → Updating Redux with ID length:", newID.length);
                            console.log("   → Backend will validate proof and set isVerified status");
                            dispatch(setProfile(updatedReduxProfile));
                          }

                          // ✅ NEW: Trigger auto-save after verification
                          console.log("🔄 [RECLAIM] Triggering auto-save for Coinbase KYC verification (Host Step 1)");
                          console.log("   → Verification source: Reclaim Protocol");
                          autoSaveOnVerification(newID).then(() => {
                            // ✅ Refresh profile after auto-save completes
                            setTimeout(async () => {
                              try {
                                const refreshedProfile = await api("profile/getProfile", {
                                  walletAddress: account,
                                });
                                if (refreshedProfile) {
                                  dispatch(setProfile(refreshedProfile));
                                  console.log("✅ [RECLAIM] Profile refreshed after Coinbase KYC verification (Host Step 1)");
                                  console.log("   → Is Verified:", refreshedProfile.isVerified);
                                  console.log("   → Verification Level:", refreshedProfile.verificationLevel);
                                  console.log("   → Has KYC:", refreshedProfile.verifications?.kyc?.verified);
                                  console.log("   → Has Emirates ID:", refreshedProfile.verifications?.emiratesId?.verified);
                                  toast.success("✅ KYC verification complete! Now verify your Emirates ID to complete host verification.", {
                                    autoClose: 5000,
                                  });
                                }
                              } catch (error) {
                                console.warn("⚠️ [RECLAIM] Failed to refresh profile:", error);
                              }
                            }, 1000);
                          });
                        }}
                      />
                      <ReclaimZKP
                        providerId={3}
                        txt={"Binance KYC"}
                        profileFirstName={profile.firstName}
                        profileLastName={profile.lastName}
                        setReturn={(value) => {
                          console.log("🔐 [RECLAIM] Received Binance KYC proof data from Reclaim Protocol (Host):");
                          console.log("   → Proof data length:", value?.length || 0);
                          console.log("   → Proof data preview:", value?.substring(0, 100));
                          console.log("   → Verification source: Reclaim Protocol");
                          console.log("   → Verification type: KYC (Host Step 1)");
                          console.log("   → Provider: Binance");
                          console.log("   → Timestamp:", new Date().toISOString());
                          
                          // ✅ FIX: Prevent duplicate proof appending
                          const currentParts = (profile.ID || "").split("/");
                          const basePart = currentParts[0] || (account || generateRandom8DigitInteger().toString());
                          const existingProofs = currentParts.slice(1).filter(p => p && p !== "");
                          
                          const proofAlreadyExists = existingProofs.some(p => p === value);
                          
                          let newID;
                          if (proofAlreadyExists) {
                            console.log("⚠️ [RECLAIM] Proof already exists in ID, not appending duplicate");
                            newID = profile.ID;
                          } else {
                            console.log("✅ [RECLAIM] Appending new proof to ID");
                            newID = basePart + "/" + value;
                          }
                          
                          justVerifiedRef.current = true;
                          verificationDataRef.current = newID;
                          console.log("   → Stored Binance verification in ref, length:", newID.length);
                          
                          // ✅ SECURITY: Do NOT set isVerified here - let backend validate the proof
                          const updatedProfile = { 
                            ...profile, 
                            ID: newID
                            // isVerified will be set by backend after validating the proof
                          };
                          setProfiles(updatedProfile);
                          
                          if (value && currentProfile) {
                            const updatedReduxProfile = {
                              ...currentProfile,
                              ID: newID
                              // Let backend set isVerified and verificationLevel after validation
                            };
                            console.log("   → Backend will validate proof and set isVerified status");
                            dispatch(setProfile(updatedReduxProfile));
                          }

                          // ✅ NEW: Trigger auto-save after verification
                          console.log("🔄 [RECLAIM] Triggering auto-save for Binance KYC verification (Host Step 1)");
                          console.log("   → Verification source: Reclaim Protocol");
                          autoSaveOnVerification(newID).then(() => {
                            // ✅ Refresh profile after auto-save completes
                            setTimeout(async () => {
                              try {
                                const refreshedProfile = await api("profile/getProfile", {
                                  walletAddress: account,
                                });
                                if (refreshedProfile) {
                                  dispatch(setProfile(refreshedProfile));
                                  console.log("✅ [RECLAIM] Profile refreshed after Binance KYC verification (Host Step 1)");
                                  console.log("   → Is Verified:", refreshedProfile.isVerified);
                                  console.log("   → Verification Level:", refreshedProfile.verificationLevel);
                                  console.log("   → Has KYC:", refreshedProfile.verifications?.kyc?.verified);
                                  console.log("   → Has Emirates ID:", refreshedProfile.verifications?.emiratesId?.verified);
                                  toast.success("✅ KYC verification complete! Now verify your Emirates ID to complete host verification.", {
                                    autoClose: 5000,
                                  });
                                }
                              } catch (error) {
                                console.warn("⚠️ [RECLAIM] Failed to refresh profile:", error);
                              }
                            }, 1000);
                          });
                        }}
                      />
                      <ReclaimZKP
                        providerId={4}
                        txt={"OKX KYC"}
                        profileFirstName={profile.firstName}
                        profileLastName={profile.lastName}
                        setReturn={(value) => {
                          console.log("🔐 [RECLAIM] Received OKX KYC proof data from Reclaim Protocol (Host):");
                          console.log("   → Proof data length:", value?.length || 0);
                          console.log("   → Proof data preview:", value?.substring(0, 100));
                          console.log("   → Verification source: Reclaim Protocol");
                          console.log("   → Verification type: KYC (Host Step 1)");
                          console.log("   → Provider: OKX");
                          console.log("   → Timestamp:", new Date().toISOString());
                          
                          // ✅ FIX: Prevent duplicate proof appending
                          const currentParts = (profile.ID || "").split("/");
                          const basePart = currentParts[0] || (account || generateRandom8DigitInteger().toString());
                          const existingProofs = currentParts.slice(1).filter(p => p && p !== "");
                          
                          const proofAlreadyExists = existingProofs.some(p => p === value);
                          
                          let newID;
                          if (proofAlreadyExists) {
                            console.log("⚠️ [RECLAIM] Proof already exists in ID, not appending duplicate");
                            newID = profile.ID;
                          } else {
                            console.log("✅ [RECLAIM] Appending new proof to ID");
                            newID = basePart + "/" + value;
                          }
                          
                          justVerifiedRef.current = true;
                          verificationDataRef.current = newID;
                          console.log("   → Stored OKX verification in ref, length:", newID.length);
                          
                          // ✅ SECURITY: Do NOT set isVerified here - let backend validate the proof
                          const updatedProfile = { 
                            ...profile, 
                            ID: newID
                            // isVerified will be set by backend after validating the proof
                          };
                          setProfiles(updatedProfile);
                          
                          if (value && currentProfile) {
                            const updatedReduxProfile = {
                              ...currentProfile,
                              ID: newID
                              // Let backend set isVerified and verificationLevel after validation
                            };
                            console.log("   → Backend will validate proof and set isVerified status");
                            dispatch(setProfile(updatedReduxProfile));
                          }

                          // ✅ NEW: Trigger auto-save after verification
                          console.log("🔄 [RECLAIM] Triggering auto-save for OKX KYC verification (Host Step 1)");
                          console.log("   → Verification source: Reclaim Protocol");
                          autoSaveOnVerification(newID).then(() => {
                            // ✅ Refresh profile after auto-save completes
                            setTimeout(async () => {
                              try {
                                const refreshedProfile = await api("profile/getProfile", {
                                  walletAddress: account,
                                });
                                if (refreshedProfile) {
                                  dispatch(setProfile(refreshedProfile));
                                  console.log("✅ [RECLAIM] Profile refreshed after OKX KYC verification (Host Step 1)");
                                  console.log("   → Is Verified:", refreshedProfile.isVerified);
                                  console.log("   → Verification Level:", refreshedProfile.verificationLevel);
                                  console.log("   → Has KYC:", refreshedProfile.verifications?.kyc?.verified);
                                  console.log("   → Has Emirates ID:", refreshedProfile.verifications?.emiratesId?.verified);
                                  toast.success("✅ KYC verification complete! Now verify your Emirates ID to complete host verification.", {
                                    autoClose: 5000,
                                  });
                                }
                              } catch (error) {
                                console.warn("⚠️ [RECLAIM] Failed to refresh profile:", error);
                              }
                            }, 1000);
                          });
                        }}
                      />
                    </>
                  )}

                  {/* ✅ NEW: Host verification - Show Emirates ID option only after KYC is completed */}
                  {mode === "host" && (currentProfile?.verifications?.kyc?.verified || false) && (
                    <ReclaimZKP
                      txt={"Verify Emirates ID"}
                      profileFirstName={profile.firstName}
                      profileLastName={profile.lastName}
                      setReturn={(value) => {
                        console.log("🔐 [RECLAIM] Received Emirates ID proof from Reclaim Protocol");
                        console.log("   → Proof data length:", value?.length || 0);
                        console.log("   → Proof data preview:", value?.substring(0, 100));
                        console.log("   → Verification source: Reclaim Protocol");
                        console.log("   → Verification type: Emirates ID (Host verification)");
                        console.log("   → Timestamp:", new Date().toISOString());
                        
                        // ✅ FIX: Prevent duplicate proof appending
                        const currentParts = (profile.ID || "").split("/");
                        const basePart = currentParts[0] || (account || generateRandom8DigitInteger().toString());
                        const existingProofs = currentParts.slice(1).filter(p => p && p !== "");
                        
                        const proofAlreadyExists = existingProofs.some(p => p === value);
                        
                        let newID;
                        if (proofAlreadyExists) {
                          console.log("⚠️ [RECLAIM] Proof already exists in ID, not appending duplicate");
                          newID = profile.ID;
                        } else {
                          console.log("✅ [RECLAIM] Appending new proof to ID");
                          newID = basePart + "/" + value;
                        }
                        
                        justVerifiedRef.current = true;
                        verificationDataRef.current = newID;
                        console.log("   → Stored Emirates ID in ref, length:", newID.length);
                        console.log("   → New ID preview:", newID.substring(0, 100));
                        
                        // ✅ SECURITY: Do NOT set isVerified here - let backend validate the proof
                        const updatedProfile = { 
                          ...profile, 
                          ID: newID
                          // isVerified will be set by backend after validating the proof
                        };
                        setProfiles(updatedProfile);
                        
                        if (value && currentProfile) {
                          const updatedReduxProfile = {
                            ...currentProfile,
                            ID: newID
                            // Let backend set isVerified and verificationLevel after validation
                          };
                          console.log("   → Backend will validate proof and set isVerified status");
                          dispatch(setProfile(updatedReduxProfile));
                        }

                        // ✅ NEW: Trigger auto-save after verification
                        console.log("🔄 [RECLAIM] Triggering auto-save for Emirates ID verification (Host Step 2)");
                        console.log("   → Verification source: Reclaim Protocol");
                        autoSaveOnVerification(newID).then(() => {
                          // ✅ Refresh profile after auto-save completes
                          setTimeout(async () => {
                            try {
                              const refreshedProfile = await api("profile/getProfile", {
                                walletAddress: account,
                              });
                              if (refreshedProfile) {
                                dispatch(setProfile(refreshedProfile));
                                console.log("✅ [RECLAIM] Profile refreshed after Emirates ID verification (Host Step 2)");
                                console.log("   → Is Verified:", refreshedProfile.isVerified);
                                console.log("   → Verification Level:", refreshedProfile.verificationLevel);
                                console.log("   → Has KYC:", refreshedProfile.verifications?.kyc?.verified);
                                console.log("   → Has Emirates ID:", refreshedProfile.verifications?.emiratesId?.verified);
                                
                                // Check if both verifications are complete
                                const hasKyc = refreshedProfile.verifications?.kyc?.verified || false;
                                const hasEmiratesId = refreshedProfile.verifications?.emiratesId?.verified || false;
                                
                                if (hasKyc && hasEmiratesId) {
                                  toast.success("🎉 Host verification complete! You are now fully verified (KYC + Emirates ID).", {
                                    autoClose: 5000,
                                  });
                                } else {
                                  toast.success("✅ Emirates ID verification complete!", {
                                    autoClose: 3000,
                                  });
                                }
                              }
                            } catch (error) {
                              console.warn("⚠️ [RECLAIM] Failed to refresh profile:", error);
                            }
                          }, 1000);
                        });
                      }}
                    />
                  )}
                  {mode === "traveler" && (
                    <>
                      <ReclaimZKP
                        providerId={2}
                        txt={"Coinbase KYC"}
                        profileFirstName={profile.firstName}
                        profileLastName={profile.lastName}
                        setReturn={(value) => {
                          // ✅ SECURITY FIX: value now contains actual proof data, not just 'true'
                          console.log("🔐 [RECLAIM] Received Coinbase KYC proof data from Reclaim Protocol:");
                          console.log("   → Proof data type:", typeof value);
                          console.log("   → Proof data length:", value?.length || 0);
                          console.log("   → Proof data preview:", value?.substring(0, 200));
                          console.log("   → Verification source: Reclaim Protocol");
                          console.log("   → Verification type: KYC (Traveler verification)");
                          console.log("   → Provider: Coinbase");
                          console.log("   → Timestamp:", new Date().toISOString());
                          console.log("   → Current profile.ID:", profile.ID);
                          
                          // ✅ FIX: Prevent duplicate proof appending
                          const currentParts = (profile.ID || "").split("/");
                          const basePart = currentParts[0] || (account || generateRandom8DigitInteger().toString());
                          const existingProofs = currentParts.slice(1).filter(p => p && p !== "");
                          
                          // Check if this exact proof already exists
                          const proofAlreadyExists = existingProofs.some(p => p === value);
                          
                          let newID;
                          if (proofAlreadyExists) {
                            console.log("⚠️ Proof already exists in ID, not appending duplicate");
                            newID = profile.ID;
                          } else {
                            console.log("✅ Appending new proof to ID");
                            newID = basePart + "/" + value;
                          }
                          
                          console.log("   → New profile.ID length:", newID.length);
                          console.log("   → New profile.ID preview:", newID.substring(0, 200));
                          
                          // ✅ CRITICAL: Store in ref to survive Redux updates
                          justVerifiedRef.current = true;
                          verificationDataRef.current = newID;
                          console.log("   → Stored in verificationDataRef");
                          
                          // ✅ SECURITY: Do NOT set isVerified here - let backend validate the proof
                          const updatedProfile = { 
                            ...profile, 
                            ID: newID
                            // isVerified will be set by backend after validating the proof
                          };
                          
                          setProfiles(updatedProfile);
                          
                          // ✅ Update Redux state with proof data (backend will validate and set isVerified)
                          if (value && currentProfile) {
                            const updatedReduxProfile = {
                              ...currentProfile,
                              ID: newID
                              // Let backend set isVerified and verificationLevel after validation
                            };
                            console.log("   → Updating Redux with ID length:", newID.length);
                            console.log("   → Backend will validate proof and set isVerified status");
                            dispatch(setProfile(updatedReduxProfile));
                          }

                          // ✅ NEW: Trigger auto-save after verification
                          console.log("🔄 [RECLAIM] Triggering auto-save for Coinbase KYC verification");
                          console.log("   → Verification source: Reclaim Protocol");
                          autoSaveOnVerification(newID).then(() => {
                            // ✅ Refresh profile after auto-save completes
                            setTimeout(async () => {
                              try {
                                const refreshedProfile = await api("profile/getProfile", {
                                  walletAddress: account,
                                });
                                if (refreshedProfile) {
                                  dispatch(setProfile(refreshedProfile));
                                  console.log("✅ [RECLAIM] Profile refreshed after Coinbase KYC verification");
                                  console.log("   → Is Verified:", refreshedProfile.isVerified);
                                  console.log("   → Verification Level:", refreshedProfile.verificationLevel);
                                }
                              } catch (error) {
                                console.warn("⚠️ [RECLAIM] Failed to refresh profile:", error);
                              }
                            }, 1000);
                          });
                        }}
                      />
                      <ReclaimZKP
                        providerId={3}
                        txt={"Binance KYC"}
                        profileFirstName={profile.firstName}
                        profileLastName={profile.lastName}
                        setReturn={(value) => {
                          console.log("🔐 [RECLAIM] Received Binance KYC proof data from Reclaim Protocol");
                          console.log("   → Proof data length:", value?.length || 0);
                          console.log("   → Proof data preview:", value?.substring(0, 100));
                          console.log("   → Verification source: Reclaim Protocol");
                          console.log("   → Verification type: KYC (Traveler verification)");
                          console.log("   → Provider: Binance");
                          console.log("   → Timestamp:", new Date().toISOString());
                          
                          // ✅ FIX: Prevent duplicate proof appending
                          const currentParts = (profile.ID || "").split("/");
                          const basePart = currentParts[0] || (account || generateRandom8DigitInteger().toString());
                          const existingProofs = currentParts.slice(1).filter(p => p && p !== "");
                          
                          const proofAlreadyExists = existingProofs.some(p => p === value);
                          
                          let newID;
                          if (proofAlreadyExists) {
                            console.log("⚠️ [RECLAIM] Proof already exists in ID, not appending duplicate");
                            newID = profile.ID;
                          } else {
                            console.log("✅ [RECLAIM] Appending new proof to ID");
                            newID = basePart + "/" + value;
                          }
                          
                          justVerifiedRef.current = true;
                          verificationDataRef.current = newID;
                          console.log("   → Stored Binance verification in ref, length:", newID.length);
                          
                          // ✅ SECURITY: Do NOT set isVerified here - let backend validate the proof
                          const updatedProfile = { 
                            ...profile, 
                            ID: newID
                            // isVerified will be set by backend after validating the proof
                          };
                          setProfiles(updatedProfile);
                          
                          if (value && currentProfile) {
                            const updatedReduxProfile = {
                              ...currentProfile,
                              ID: newID
                              // Let backend set isVerified and verificationLevel after validation
                            };
                            console.log("   → Backend will validate proof and set isVerified status");
                            dispatch(setProfile(updatedReduxProfile));
                          }

                          // ✅ NEW: Trigger auto-save after verification
                          console.log("🔄 [RECLAIM] Triggering auto-save for Binance KYC verification");
                          console.log("   → Verification source: Reclaim Protocol");
                          autoSaveOnVerification(newID).then(() => {
                            // ✅ Refresh profile after auto-save completes
                            setTimeout(async () => {
                              try {
                                const refreshedProfile = await api("profile/getProfile", {
                                  walletAddress: account,
                                });
                                if (refreshedProfile) {
                                  dispatch(setProfile(refreshedProfile));
                                  console.log("✅ [RECLAIM] Profile refreshed after Binance KYC verification");
                                  console.log("   → Is Verified:", refreshedProfile.isVerified);
                                  console.log("   → Verification Level:", refreshedProfile.verificationLevel);
                                }
                              } catch (error) {
                                console.warn("⚠️ [RECLAIM] Failed to refresh profile:", error);
                              }
                            }, 1000);
                          });
                        }}
                      />
                      <ReclaimZKP
                        providerId={4}
                        txt={"OKX KYC"}
                        profileFirstName={profile.firstName}
                        profileLastName={profile.lastName}
                        setReturn={(value) => {
                          console.log("🔐 [RECLAIM] Received OKX KYC proof data from Reclaim Protocol");
                          console.log("   → Proof data length:", value?.length || 0);
                          console.log("   → Proof data preview:", value?.substring(0, 100));
                          console.log("   → Verification source: Reclaim Protocol");
                          console.log("   → Verification type: KYC (Traveler verification)");
                          console.log("   → Provider: OKX");
                          console.log("   → Timestamp:", new Date().toISOString());
                          
                          // ✅ FIX: Prevent duplicate proof appending
                          const currentParts = (profile.ID || "").split("/");
                          const basePart = currentParts[0] || (account || generateRandom8DigitInteger().toString());
                          const existingProofs = currentParts.slice(1).filter(p => p && p !== "");
                          
                          const proofAlreadyExists = existingProofs.some(p => p === value);
                          
                          let newID;
                          if (proofAlreadyExists) {
                            console.log("⚠️ [RECLAIM] Proof already exists in ID, not appending duplicate");
                            newID = profile.ID;
                          } else {
                            console.log("✅ [RECLAIM] Appending new proof to ID");
                            newID = basePart + "/" + value;
                          }
                          
                          justVerifiedRef.current = true;
                          verificationDataRef.current = newID;
                          console.log("   → Stored OKX verification in ref, length:", newID.length);
                          
                          // ✅ SECURITY: Do NOT set isVerified here - let backend validate the proof
                          const updatedProfile = { 
                            ...profile, 
                            ID: newID
                            // isVerified will be set by backend after validating the proof
                          };
                          setProfiles(updatedProfile);
                          
                          if (value && currentProfile) {
                            const updatedReduxProfile = {
                              ...currentProfile,
                              ID: newID
                              // Let backend set isVerified and verificationLevel after validation
                            };
                            console.log("   → Backend will validate proof and set isVerified status");
                            dispatch(setProfile(updatedReduxProfile));
                          }

                          // ✅ NEW: Trigger auto-save after verification
                          console.log("🔄 [RECLAIM] Triggering auto-save for OKX KYC verification");
                          console.log("   → Verification source: Reclaim Protocol");
                          autoSaveOnVerification(newID).then(() => {
                            // ✅ Refresh profile after auto-save completes
                            setTimeout(async () => {
                              try {
                                const refreshedProfile = await api("profile/getProfile", {
                                  walletAddress: account,
                                });
                                if (refreshedProfile) {
                                  dispatch(setProfile(refreshedProfile));
                                  console.log("✅ [RECLAIM] Profile refreshed after OKX KYC verification");
                                  console.log("   → Is Verified:", refreshedProfile.isVerified);
                                  console.log("   → Verification Level:", refreshedProfile.verificationLevel);
                                }
                              } catch (error) {
                                console.warn("⚠️ [RECLAIM] Failed to refresh profile:", error);
                              }
                            }, 1000);
                          });
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
              <div className="w-full space-y-[8px] sm:space-y-[10px]" hidden={params.address}>
                <div className="font-semibold text-sm sm:text-base">Email address</div>
                <div className="bg-white px-[10px] sm:px-[12px] w-full py-[8px] border-[2px] border-[#E3E3E3] rounded-[10px] sm:rounded-[12px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                  <input
                    disabled={params.address}
                    className="outline-none w-full text-sm sm:text-base profile-input-mobile"
                    type="email"
                    value={profile.email}
                    onChange={(e) =>
                      setProfiles({
                        ...profile,
                        email: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="w-full space-y-[8px] sm:space-y-[10px]">
                <div className="font-semibold text-sm sm:text-base">Company</div>
                <div className={`px-[10px] sm:px-[12px] w-full py-[8px] border-[2px] border-[#E3E3E3] rounded-[10px] sm:rounded-[12px] ${params.address ? 'bg-white' : 'bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]'}`}>
                  <input
                    disabled={params.address}
                    className={`outline-none w-full text-sm sm:text-base profile-input-mobile ${params.address ? 'bg-white text-gray-900' : ''}`}
                    style={params.address ? { backgroundColor: 'white', color: '#111827' } : {}}
                    value={profile.company}
                    onChange={(e) =>
                      setProfiles({
                        ...profile,
                        company: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="w-full space-y-[8px] sm:space-y-[10px]">
                <div hidden={params.address} className="font-semibold text-sm sm:text-base">
                  About you
                </div>
                <div className={`px-[10px] sm:px-[12px] w-full py-[8px] border-[2px] border-[#E3E3E3] rounded-[10px] sm:rounded-[12px] ${params.address ? 'bg-white' : 'bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]'}`}>
                  <textarea
                    disabled={params.address}
                    className={`outline-none w-full min-h-[100px] sm:min-h-[140px] text-sm sm:text-base resize-none profile-textarea-mobile ${params.address ? 'bg-white text-gray-900' : ''}`}
                    style={params.address ? { backgroundColor: 'white', color: '#111827' } : {}}
                    value={profile.bio}
                    onChange={(e) =>
                      setProfiles({
                        ...profile,
                        bio: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div hidden={params.address}>
                <div className="flex justify-end">  
                  <PurpleButton text="Save changes" onClick={submitChanges} className="profile-button-mobile" />
                </div>
              </div>
            </div>
          </div>
          <div hidden={params.address}>
            {mode === "host" && (
              <>
                <div className="h-full min-h-[200px] sm:min-h-[240px] bg-white flex top-0 gap-[10px] justify-around items-center overflow-auto scrollbarwidth w-full rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] p-4 profile-listings-mobile">
                  {listings.map((nft) => {
                    return (
                      <>
                        <RentalItem
                          showArrow={false}
                          token_id={nft.token_id}
                          imageHeight={150}
                          onlyImages
                          className="profile-listing-item-mobile"
                        />
                      </>
                    );
                  })}
                  {listings.length === 0 && (
                    <div className="flex flex-col space-y-3 justify-around items-center h-full w-full">
                      <EmptyNft />
                      <div className="font-semibold text-sm sm:text-base">No List property</div>
                      <PurpleButton
                        text={
                          <div
                            className="min-w-[100px] text-center"
                            onClick={() => navigate("/dashboard/host/nfts")}
                          >
                            List property
                          </div>
                        }
                        className="profile-button-mobile"
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
          {profile.review?.length > 0 && <Review reviewData={profile.review} />}
        </Fade>
      </div>
    </div>
  );
};
